module.exports = __webpack_public_path__ + "img/收费计算器@3x.png";